import { render } from "./ChooseLabelSetModal.vue?vue&type=template&id=565aea8a&scoped=true"
import script from "./ChooseLabelSetModal.vue?vue&type=script&lang=js"
export * from "./ChooseLabelSetModal.vue?vue&type=script&lang=js"

import "../../assets/scss/choose_label_set_modal.scss?vue&type=style&index=0&id=565aea8a&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-565aea8a"]])

export default __exports__